<template>
  <Dialog :visible="visible" class="irinox-dialog-light" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '500px'}" :draggable="false"
              @update:visible="updateVisible" @show="show">
    
    <template #header>
      <img src="assets/irinox/icons/arrow_back.svg" @click="updateVisible(false)" :alt="$t('common.arrow_left')"/>
      <div>{{$t('fota.manage_fw.title')}}</div>
    </template>

    <div class="irinox-dialog-light-content layout-content">
      <div class="irinox-form p-pt-2">
        <div v-if="single" class="p-fluid p-formgrid p-grid p-pl-4 p-pr-4">
              <div class="p-field p-col-12">
                  <label for="current">{{$t('fota.manage_fw.current')}}</label>
                  <InputText id="current" type="text" v-model="currentFirmware" 
                    placeholder="-" disabled
                    />
              </div>
              <div class="p-field p-col-12">
                  <label for="desired">{{$t('fota.manage_fw.desired')}}</label>
                  <Dropdown id="desired" v-model="desiredFirmware" :options="firmwares" optionLabel="name" optionValue="id" 
                    :placeholder="$t('fota.manage_fw.desired_ph')"  
                    :class="{'p-invalid':!force && !desiredFirmware && submitted}"/>
              </div>
              <div class="p-field p-col-12 p-d-flex p-ai-center p-jc-sm-between p-mt-3">
                  <label for="force">{{$t('fota.manage_fw.force')}}</label>
                  <InputSwitch inputId="force" v-model="force" :class="{'p-invalid':!force && !desiredFirmware && submitted}" />
              </div>
          </div>
        <div v-else class="p-fluid p-formgrid p-grid p-pl-4 p-pr-4">
              <div class="p-field p-col-12">
                  <label for="desired">{{$t('fota.manage_fw.desired')}}</label>
                  <Dropdown id="desired" v-model="desiredFirmware" :options="firmwares" optionLabel="name" optionValue="id" 
                    :placeholder="$t('fota.manage_fw.desired_ph')"  
                    :class="{'p-invalid':!desiredFirmware && submitted}"/>
              </div>
          </div>
      </div>
    </div>

    <template #footer>
      <Button :label="$t('fota.manage_fw.button')" @click="buttonClick"/>
    </template>
  </Dialog>
</template>

<script>

import ApplianceService from '../../service/ApplianceService';
import { mapGetters } from 'vuex';
export default {
    emits: ['update:visible','click:button','click:open-share','click:open-lab'],
    props: {
      visible: Boolean,
      single: Boolean,
      item: Object,
    },
    data() {
        return {
          submitted: false,
          firmwares: [],
          currentFirmware: null,
          desiredFirmware: null,
          force: false,
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
        }),
    },
    created() {
      this.applianceService = new ApplianceService();
    },
    methods: {
      updateVisible(value) {
        if(!value) {
          this.submitted = false;
        }
        this.$emit("update:visible", value);
      },
      buttonClick() {
        this.submitted = true;

        if(this.single) {
          if(!this.force && !this.desiredFirmware) {
            return;
          }
          this.$emit("click:button", {
            desiredFirmware: this.desiredFirmware,
            force: this.force
          });
        } else {
          if(!this.desiredFirmware) {
            return;
          }
          this.$emit("click:button", {
            desiredFirmware: this.desiredFirmware
          });
        }

      },
      show() {
        this.submitted = false;
        this.currentFirmware = null;
        this.desiredFirmware = this.item.desiredFirmware.firmwareId;
        this.force = false;
        if(this.single) {
          this.currentFirmware = this.item.currentFirmware;
          this.applianceService.getFirmwareListByAppliance(this.personaltoken, this.item.serialNumber)
            .then((firmwares) => {
              this.firmwares = [];
              firmwares.forEach(function(f) {
                this.firmwares.push({
                  id: f.firmwareId,
                  name: f.version
                });
              }.bind(this));
            })
            .catch(error => {
              console.error("EXCEPTION "+error);
              this.firmwares = [];
            });
        } else {
          this.currentFirmware = null;
          this.applianceService.getFirmwareListByModel(this.personaltoken, this.item.modelId, this.item.brand, this.item.country)
            .then((firmwares) => {
              this.firmwares = [];
              firmwares.forEach(function(f) {
                this.firmwares.push({
                  id: f.firmwareId,
                  name: f.version
                });
              }.bind(this));
            })
            .catch(error => {
              console.error("EXCEPTION "+error);
              this.firmwares = [];
            });
        }
      },
    }
}
</script>

<style scoped>

.p-dialog.irinox-dialog-light .p-button {
  width: unset;
}

</style>